import _objectSpread from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["transition"];
import * as React from 'react';
import Tabs from '@restart/ui/Tabs';
import getTabTransitionComponent from './getTabTransitionComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const TabContainer = _ref => {
  let {
      transition
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tabs, _objectSpread(_objectSpread({}, props), {}, {
    transition: getTabTransitionComponent(transition)
  }));
};
TabContainer.displayName = 'TabContainer';
export default TabContainer;